import styled from '@emotion/styled';

import { Actions, Field } from 'components/layout/Auth/AuthForm/styles';
import TokenInput from 'design-system/TokenInput';
import { authColors } from 'design-system/tokens';

export const CONTENT_WIDTH = '647px';

const FIELD_WIDTH = '323px';

export const NarrowField = styled(Field)`
  width: ${FIELD_WIDTH};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const NarrowActions = styled(Actions)`
  width: ${FIELD_WIDTH};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SmallTokenInput = styled(TokenInput)`
  input {
    width: 32px;
    height: 32px;
    font-size: 22px;
    line-height: 32px;
  }
`;

export const Countdown = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textStrong};
`;

export const OnboardingTitle = styled.h1`
  margin: 0;
  display: flex;
  align-items: center;
  font-family: 'Mangueira', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  color: ${authColors.textStrong};

  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`;

export const OnboardingSubtitle = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  color: ${authColors.textStrong};
`;

export const OnboardingIntro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldWithHelp = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${FIELD_WIDTH};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const HelpLink = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  text-align: right;
  border: none;
  background: transparent;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${authColors.brand};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${authColors.brand};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const TitleMedium = styled.h2`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${authColors.textStrong};
`;

export const MaskedEmail = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  color: ${authColors.textStrong};
`;

export const RulesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RulesTitle = styled.strong`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  color: ${authColors.textStrong};
`;

export const RulesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const RuleRow = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textBody};

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;

export const RuleOk = styled.span`
  display: inline-flex;
  color: #4ec937;
`;

export const RuleFail = styled.span`
  display: inline-flex;
  color: ${authColors.required};
`;
